import { useKeycloak } from "@react-keycloak/web";
import { Table } from 'reactstrap';
import PrevVybaveni from './PrevVybaveni';

function ListingVybaveni(props: any) {
    const { keycloak, initialized } = useKeycloak();
    /*
    console.log("<ListingVybaveni debug of vars")
    console.log("props")
    console.log(props)
    console.log("-END-")
    */
    return (<Table striped hover size="sm">
            <thead>
                <tr>
                    <th>KÓD</th>
                    <th>NÁZEV</th>
                    <th>RODINA</th>
                    <th>VZOREK</th>
                    <th>MODIFIKACE</th>
                    <th>POPIS</th>
                    <th>DESIGN</th>
                    <th>UPRAVENO</th>
                    {keycloak.authenticated && (<th>VIDITELNOST</th>)}
                </tr>
            </thead>
            <tbody>
                {(props.vybaveni.length!==0) ?
                props.vybaveni.map((vybaveni: any) => <PrevVybaveni key={vybaveni.id} vybaveni={vybaveni} />):
                <tr><td>ZADNE VYSLEDKY NA ZAKLADE FILTROVANI</td></tr>}
            </tbody>
        </Table>)
}
export default ListingVybaveni